export default __webpack_public_path__ + "static/media/turistas-felices-barco-pies-del-lago.a38ecf3f.jpeg";